/* ProfileCardDetails.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text"];
import "./ProfileCardDetails.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@compiled/react';
import { FormattedMessage } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Text } from '@atlaskit/primitives/compiled';
import relativeDate from '../../internal/relative-date';
import messages from '../../messages';
import { AppTitleLabel, CustomLozengeContainer, DetailsGroup, DisabledInfo, JobTitleLabel, LozengeWrapper } from '../../styled/Card';
import { IconLabel } from '../Icon';
import ReportingLinesDetails from './ReportingLinesDetails';
var styles = {
  detailedListWrapperNext: "_19pkxy5q _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
  fullNameLabel: "_1reo15vq _18m915vq _11c81ixg _1bto1l2s _o5721q9c",
  noMetaLabel: "_2hwxidpf _18u0idpf _rcujxy5q _1l6uutpp",
  noMetaLabelWithHighSpecificity: "_vvzr1ixg _1hpmxy5q _1bguutpp",
  metaLabel: "_2hwxidpf _otyridpf _18u0idpf _rcujutpp",
  metaLabelWithHighSpecificity: "_2hwxidpf _otyridpf _18u0idpf _vvzr1ixg _1hpmutpp",
  disabledAccount: "_syazi7uo",
  activeAccount: "_syaz15cr"
};
var renderName = function renderName(nickname, fullName, meta) {
  if (!fullName && !nickname) {
    return null;
  }
  var isNicknameRedundant = !nickname || nickname === fullName;
  var shownNickname = " (".concat(nickname, ") ");
  var displayName = isNicknameRedundant ? fullName : "".concat(fullName).concat(shownNickname);
  return /*#__PURE__*/React.createElement(Box, {
    as: "h2",
    xcss: cx(styles.fullNameLabel, styles.activeAccount, meta ? fg('enable_absolute_positioning_profile_card') ? styles.metaLabelWithHighSpecificity : styles.metaLabel : fg('enable_absolute_positioning_profile_card') ? styles.noMetaLabelWithHighSpecificity : styles.noMetaLabel),
    testId: "profilecard-name",
    id: "profilecard-name-label"
  }, displayName);
};
var disabledAccountDesc = function disabledAccountDesc(statusModifiedDate, disabledAccountMessage) {
  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'closed';
  // consumer does not want to use built-in message
  if (disabledAccountMessage) {
    return disabledAccountMessage;
  }
  var date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
  var relativeDateKey = relativeDate(date);
  var msgKey = relativeDateKey ? "".concat(status, "AccountDescMsgHasDate").concat(relativeDateKey) : "".concat(status, "AccountDescMsgNoDate");
  var secondSentence = /*#__PURE__*/React.createElement(FormattedMessage, messages[msgKey]);
  return /*#__PURE__*/React.createElement(Text, {
    as: "p",
    testId: "profilecard-disabled-account"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.generalDescMsgForDisabledUser), " ", secondSentence);
};
var CustomLozenges = function CustomLozenges(_ref) {
  var _ref$lozenges = _ref.lozenges,
    lozenges = _ref$lozenges === void 0 ? [] : _ref$lozenges;
  if (lozenges.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CustomLozengeContainer, null, lozenges.map(function (_ref2, index) {
    var text = _ref2.text,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Lozenge, _extends({}, otherProps, {
      key: index
    }), text);
  }));
};
var ServiceAccountProfileCardDetails = function ServiceAccountProfileCardDetails(props) {
  var fullName = props.fullName,
    nickname = props.nickname;
  return /*#__PURE__*/React.createElement(DetailsGroup, null, renderName(nickname, fullName), /*#__PURE__*/React.createElement(AppTitleLabel, null, "SERVICE ACCOUNT"));
};
var BotProfileCardDetails = function BotProfileCardDetails(props) {
  var fullName = props.fullName,
    nickname = props.nickname;
  return /*#__PURE__*/React.createElement(DetailsGroup, null, renderName(nickname, fullName), /*#__PURE__*/React.createElement(AppTitleLabel, null, "APP"));
};
var DisabledProfileCardDetails = function DisabledProfileCardDetails(props) {
  var companyName = props.companyName,
    disabledAccountMessage = props.disabledAccountMessage,
    fullName = props.fullName,
    _props$hasDisabledAcc = props.hasDisabledAccountLozenge,
    hasDisabledAccountLozenge = _props$hasDisabledAcc === void 0 ? true : _props$hasDisabledAcc,
    nickname = props.nickname,
    status = props.status,
    statusModifiedDate = props.statusModifiedDate;
  var name = status === 'inactive' ? fullName || nickname : nickname || /*#__PURE__*/React.createElement(FormattedMessage, messages.disabledAccountDefaultName);
  return /*#__PURE__*/React.createElement(DetailsGroup, null, /*#__PURE__*/React.createElement(Box, {
    as: "h2",
    xcss: cx(styles.fullNameLabel, styles.noMetaLabel, styles.disabledAccount),
    testId: "profilecard-name",
    id: "profilecard-name-label"
  }, name), hasDisabledAccountLozenge && /*#__PURE__*/React.createElement(LozengeWrapper, null, /*#__PURE__*/React.createElement(Lozenge, {
    appearance: "default",
    isBold: true
  }, status === 'inactive' ? /*#__PURE__*/React.createElement(FormattedMessage, messages.inactiveAccountMsg) : /*#__PURE__*/React.createElement(FormattedMessage, messages.closedAccountMsg))), /*#__PURE__*/React.createElement(DisabledInfo, null, disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && /*#__PURE__*/React.createElement(IconLabel, {
    icon: "companyName"
  }, companyName));
};
export var ProfileCardDetails = function ProfileCardDetails(props) {
  var meta = props.meta,
    status = props.status;
  if (props.isServiceAccount) {
    return /*#__PURE__*/React.createElement(ServiceAccountProfileCardDetails, props);
  }
  if (props.isBot) {
    return /*#__PURE__*/React.createElement(BotProfileCardDetails, props);
  }
  if (status === 'inactive' || status === 'closed') {
    return /*#__PURE__*/React.createElement(DisabledProfileCardDetails, _extends({}, props, {
      status: status
    }));
  }
  return /*#__PURE__*/React.createElement(DetailsGroup, null, renderName(props.nickname, props.fullName, meta), meta && /*#__PURE__*/React.createElement(JobTitleLabel, null, meta), /*#__PURE__*/React.createElement(CustomLozenges, {
    lozenges: props.customLozenges
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.detailedListWrapperNext
  }, /*#__PURE__*/React.createElement(IconLabel, {
    icon: "email",
    extraTopSpace: true
  }, props.email), /*#__PURE__*/React.createElement(IconLabel, {
    icon: "time"
  }, props.timestring), /*#__PURE__*/React.createElement(IconLabel, {
    icon: "companyName"
  }, props.companyName), /*#__PURE__*/React.createElement(IconLabel, {
    icon: "location"
  }, props.location)), /*#__PURE__*/React.createElement(ReportingLinesDetails, {
    reportingLines: props.reportingLines,
    reportingLinesProfileUrl: props.reportingLinesProfileUrl,
    onReportingLinesClick: props.onReportingLinesClick,
    fireAnalyticsWithDuration: props.fireAnalyticsWithDuration,
    fireAnalyticsWithDurationNext: props.fireAnalyticsWithDurationNext
  }));
};